import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import {get} from '../Storage';

// Init Configuration
var AppSettings = get();
var componentName = AppSettings.appId + 'UpdateUserComponent';

var styles = AppSettings.styles;

class UpdateUser extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            error: false,
            errorMessage: "",
            data: null,
            showLoading: true,
        }

        this.getUserData = this.getUserData.bind(this);
    }

    componentDidMount(){
        this.getUserData();
     }

    getUserData() {
        
        this.setState({
            showLoading: true
        });

        var url = AppSettings['env'].urlUserBoxUser;
        axios.get(url)
            .then(({data, status, statusText}) => {
                var showLoading = false;
                if (data.errors.length == 0) {
                    this.setState({
                        error: false,
                        errorMessage: "",
                        data: data,
                        showLoading: showLoading
                    });
                } else {
                    this.setState({
                        error: true,
                        errorMessage: <KeepAlive />,
                        data: null,
                        showLoading: showLoading

                    });
                }
            })

            .catch(function(error) {
                this.setState({
                    error: true,
                    errorMessage: "Si è verificato un problema",
                    data: null,
                    showLoading: false
                });
            });
    }

    render() {

        if(this.state.data != null){
            return (
                <div id="mg-updateuser" className="mg-user-widget">
                        <p>Ruolo utente</p><p>{this.state.data.role}</p>
                        <p>Alias</p><p>{this.state.data.alias}</p>
                </div>
            );
        }
        else{
            return (
                <div id="mg-updateuser" className="mg-user-widget">
                        <p>Si è verificato un problema, si prega di ricaricare la pagina</p>
                </div>
            );
        }
    }
}

UpdateUser.displayName = componentName;

// PropTypes validation
UpdateUser.propTypes = {
    data: PropTypes.object.isRequired
};
UpdateUser.contextTypes = {
    openLinkPopup: PropTypes.func
}
// default props
UpdateUser.defaultProps = {
    data:{}
};

export default UpdateUser;